import apiClient from './api-client';

const atendimentosService = {
    listarPorDia: async (profissionalId) => {
        try {
          const response = await apiClient.get('/atendimentos/hoje', {
            params: {
              profissional: profissionalId
            }
          });
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
    listarPorSemana: async (profissionalId) => {
        try {
          const response = await apiClient.get('/atendimentos/semana', {
            params: {
              profissional: profissionalId
            }
          });
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      listarPorMes: async (profissionalId) => {
        try {
          const response = await apiClient.get('/atendimentos/mes', {
            params: {
              profissional: profissionalId
            }
          });
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
    listarPorMesAno: async (ano, mes, profissionalId) => {
        try {
          const response = await apiClient.get(`/atendimentos/ano/${ano}`, {
            params: {
              mes: mes,
              profissionalId: profissionalId
            }
          });
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      }
    }

export default atendimentosService;